import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { LayoutPropsEdit } from '@/main/store/@types/edit.d';

import { store } from '../store/edit';

export const EditMixin = Vue.extend({
	props: {
		layoutProps: {
			type: Object as () => LayoutPropsEdit,
			// required: true,
		},
		storeUri: {
			type: String,
			required: true,
		},
	},
	computed: {
		// TODO: časem odstranit a nahradit konkrétnimi daty přes props případně jen vybranymi daty ze storu
		...genVuexComputeds(store),
	},
	methods: {},
});
